var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "site-form",
        title: _vm.editMode
          ? _vm.$t("message.updateSiteForm")
          : _vm.$t("message.newSiteForm"),
        visible: _vm.visible,
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        size: "lg",
      },
      on: { hidden: _vm.onCancel },
    },
    [
      _c(
        "b-form",
        {
          staticClass: "d-flex flex-column justify-content-center",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.rootUserName")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.rootUserName"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.rootUserName") },
                        model: {
                          value: _vm.config.rootUserName,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "rootUserName", $$v)
                          },
                          expression: "config.rootUserName",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.rootUserName"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.rootUserEmail")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.rootUserEmail"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.rootUserEmail") },
                        model: {
                          value: _vm.config.rootUserEmail,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "rootUserEmail", $$v)
                          },
                          expression: "config.rootUserEmail",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.rootUserEmail"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.editMode
                ? _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "md-field",
                        {
                          class: {
                            "md-invalid":
                              _vm.errors.first(
                                _vm.$t("message.organizationName")
                              ) != null,
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.organizationName"))),
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: { name: _vm.$t("message.organizationName") },
                            model: {
                              value: _vm.config.organizationName,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "organizationName", $$v)
                              },
                              expression: "config.organizationName",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errors.first(
                                  _vm.$t("message.organizationName")
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.siteAddress")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.siteAddress"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.siteAddress") },
                        model: {
                          value: _vm.site.siteAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "siteAddress", $$v)
                          },
                          expression: "site.siteAddress",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.siteAddress"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.siteAlias")) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.siteAlias"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.siteAlias") },
                        model: {
                          value: _vm.site.alias,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "alias", $$v)
                          },
                          expression: "site.alias",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(_vm.errors.first(_vm.$t("message.siteAlias")))
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.customerRepLimit")
                          ) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.customerRepLimit"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|integer|min:-1|max:100",
                            expression: "'required|integer|min:-1|max:100'",
                          },
                        ],
                        attrs: {
                          max: 100,
                          min: -1,
                          name: _vm.$t("message.customerRepLimit"),
                          type: "number",
                        },
                        model: {
                          value: _vm.site.customerRepresentativeLimit,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.site,
                              "customerRepresentativeLimit",
                              $$v
                            )
                          },
                          expression: "site.customerRepresentativeLimit",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.customerRepLimit"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.customerCssUrl")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.customerCssUrl"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "url",
                            expression: "'url'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.customerCssUrl") },
                        model: {
                          value: _vm.site.customerCssUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "customerCssUrl", $$v)
                          },
                          expression: "site.customerCssUrl",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.customerCssUrl"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.customerLogoUrl")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.customerLogoUrl"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "url",
                            expression: "'url'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.customerLogoUrl") },
                        model: {
                          value: _vm.site.customerLogoUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "customerLogoUrl", $$v)
                          },
                          expression: "site.customerLogoUrl",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.customerLogoUrl"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.panelCustomCssUrl")
                          ) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.panelCustomCssUrl"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "url",
                            expression: "'url'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.panelCustomCssUrl") },
                        model: {
                          value: _vm.site.panelCustomCssUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "panelCustomCssUrl", $$v)
                          },
                          expression: "site.panelCustomCssUrl",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(
                              _vm.$t("message.panelCustomCssUrl")
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.panelLogoUrl")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.panelLogoUrl"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "url",
                            expression: "'url'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.panelLogoUrl") },
                        model: {
                          value: _vm.site.panelLogoUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "panelLogoUrl", $$v)
                          },
                          expression: "site.panelLogoUrl",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.panelLogoUrl"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.customerClientAddress")
                          ) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.customerClientAddress"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          name: _vm.$t("message.customerClientAddress"),
                        },
                        model: {
                          value: _vm.site.customerClientAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "customerClientAddress", $$v)
                          },
                          expression: "site.customerClientAddress",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(
                              _vm.$t("message.customerClientAddress")
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.clientAddress")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.clientAddress"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.clientAddress") },
                        model: {
                          value: _vm.site.clientAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.site, "clientAddress", $$v)
                          },
                          expression: "site.clientAddress",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.clientAddress"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.whatsappBasePriceValue")
                          ) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.$t("message.whatsappBasePriceValue"))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.site.whatsappBasePrice
                        ? _c(
                            "div",
                            [
                              _c("md-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: !!_vm.site.whatsappBasePrice.value
                                      ? "required|min:0|decimal"
                                      : null,
                                    expression:
                                      "!!site.whatsappBasePrice.value ? 'required|min:0|decimal' : null",
                                  },
                                ],
                                attrs: {
                                  min: 0,
                                  name: _vm.$t(
                                    "message.whatsappBasePriceValue"
                                  ),
                                  step: "0.01",
                                  type: "number",
                                },
                                model: {
                                  value: _vm.site.whatsappBasePrice.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.site.whatsappBasePrice,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "site.whatsappBasePrice.value",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first(
                                      _vm.$t("message.whatsappBasePriceValue")
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _c("div", [_vm._v("N/A")]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.basePriceValue")) !=
                          null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.basePriceValue"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:0|decimal",
                            expression: "'required|min:0|decimal'",
                          },
                        ],
                        attrs: {
                          min: 0,
                          name: _vm.$t("message.basePriceValue"),
                          step: "0.01",
                          type: "number",
                        },
                        model: {
                          value: _vm.site.basePrice.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.site.basePrice, "value", $$v)
                          },
                          expression: "site.basePrice.value",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(_vm.$t("message.basePriceValue"))
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(_vm.$t("message.currency")) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.basePriceCurrency"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: { name: _vm.$t("message.basePriceCurrency") },
                        model: {
                          value: _vm.site.basePrice.currency,
                          callback: function ($$v) {
                            _vm.$set(_vm.site.basePrice, "currency", $$v)
                          },
                          expression: "site.basePrice.currency",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(
                              _vm.$t("message.basePriceCurrency")
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "md-field",
                    {
                      class: {
                        "md-invalid":
                          _vm.errors.first(
                            _vm.$t("message.basePriceDiscount")
                          ) != null,
                      },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.basePriceDiscount"))),
                      ]),
                      _vm._v(" "),
                      _c("md-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:0|max:100|decimal",
                            expression: "'required|min:0|max:100|decimal'",
                          },
                        ],
                        attrs: {
                          max: 100,
                          min: 0,
                          name: _vm.$t("message.basePriceDiscount"),
                          step: "0.1",
                          type: "number",
                        },
                        model: {
                          value: _vm.site.basePrice.discount,
                          callback: function ($$v) {
                            _vm.$set(_vm.site.basePrice, "discount", $$v)
                          },
                          expression: "site.basePrice.discount",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.first(
                              _vm.$t("message.basePriceDiscount")
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.editMode
                ? _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "md-switch",
                        {
                          staticClass: "md-primary",
                          staticStyle: { height: "22px", margin: "0" },
                          model: {
                            value: _vm.config.isRemoteDB,
                            callback: function ($$v) {
                              _vm.$set(_vm.config, "isRemoteDB", $$v)
                            },
                            expression: "config.isRemoteDB",
                          },
                        },
                        [
                          _vm.config.isRemoteDB
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.customerDBEnabled"))
                                ),
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.customerDBDisabled"))
                                ),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.config.isRemoteDB
                        ? _c(
                            "md-field",
                            {
                              class: {
                                "md-invalid":
                                  _vm.errors.first(
                                    _vm.$t("message.mongoConnectionString")
                                  ) != null,
                              },
                            },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.mongoConnectionString")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.config.isRemoteDB
                                ? _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      name: _vm.$t(
                                        "message.mongoConnectionString"
                                      ),
                                    },
                                    model: {
                                      value: _vm.site.mongoConnectionString,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.site,
                                          "mongoConnectionString",
                                          $$v
                                        )
                                      },
                                      expression: "site.mongoConnectionString",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.config.isRemoteDB
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          _vm.$t(
                                            "message.mongoConnectionString"
                                          )
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "md-switch",
                    {
                      staticClass: "md-primary",
                      model: {
                        value: _vm.site.enable,
                        callback: function ($$v) {
                          _vm.$set(_vm.site, "enable", $$v)
                        },
                        expression: "site.enable",
                      },
                    },
                    [
                      _vm.site.enable
                        ? _c("span", [_vm._v(_vm._s(_vm.$t("message.active")))])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.passive"))),
                          ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled: _vm.loading,
                        type: "submit",
                        variant: "primary",
                      },
                    },
                    [
                      !_vm.loading
                        ? [
                            !_vm.editMode
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("message.save"))),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.$t("message.update"))),
                                ]),
                          ]
                        : [
                            _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "" },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    { on: { click: _vm.onCancel } },
                    [
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.cancel")) +
                            "\n                    "
                        ),
                      ],
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }